export enum LoginType {
  OnlyPassword,
  TwoFactorWithMail,
  TwoFactorWithSms,
}
